<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>{{
      translationService.getIngredientCSVTemplatesText()
    }}</mat-panel-title>
  </mat-expansion-panel-header>
  <button (click)="goToCreate()">
    {{ translationService.getCreateTemplateText() }}
  </button>
  <app-ingredient-template-list></app-ingredient-template-list>
</mat-expansion-panel>
